import { render, staticRenderFns } from "./OrderCard.vue?vue&type=template&id=73d81f39&scoped=true&"
import script from "./OrderCard.vue?vue&type=script&lang=js&"
export * from "./OrderCard.vue?vue&type=script&lang=js&"
import style0 from "./OrderCard.vue?vue&type=style&index=0&id=73d81f39&scoped=true&lang=css&"
import style1 from "./OrderCard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d81f39",
  null
  
)

export default component.exports